import { put, takeEvery } from "redux-saga/effects";
// import messagePopup from "../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    EVENT_SIDE_BAR_START: "EVENT_SIDE_BAR_START",
    EVENT_SIDE_BAR_SUCCESS: "EVENT_SIDE_BAR_SUCCESS",
    EVENT_SIDE_BAR_FAILED: "EVENT_SIDE_BAR_FAILED",
};

// ============================================ Actions ========================================================
export const eventSideBarStart = (data) => ({
    type: actionType.EVENT_SIDE_BAR_START,
    payload: data,
});

export const eventSideBarSuccess = (data) => ({
    type: actionType.EVENT_SIDE_BAR_SUCCESS,
    payload: data,
});

export const eventSideBarFailed = (data) => ({
    type: actionType.EVENT_SIDE_BAR_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    status: false,
    error: null,
};

export default function eventSideBarReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.EVENT_SIDE_BAR_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.EVENT_SIDE_BAR_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action.payload.status,
                error: null,
            };
        case actionType.EVENT_SIDE_BAR_FAILED:
            return {
                ...state,
                loading: false,
                status: null,
                error: action.payload.status,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* eventSideBarSaga(action) {
    try {
        yield put(eventSideBarSuccess(action?.payload));
    } catch (error) {
        yield put(eventSideBarFailed("Event Header Toggle failed"));
    }
}

export function* watchEventSideBarSaga() {
    yield takeEvery(actionType.EVENT_SIDE_BAR_START, eventSideBarSaga);
}
